import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { Accordion, Card, Spinner } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import EmpleadoForm from "./EmpleadoForm";
import axiosInstance from "../../../api/api";

const initialEmp = {
    id: null,
    porcentajeBeneficiosLey: 0,
    porcentajeAnexoNomina: 0,
    porcentajePrestacionesSociales: 0,
    porcentajePrestacionesSocialesDirectos: 0,
    porcentajePrestacionesSocialesIndirectos: 0,
    totalTrabajadores: 0,
    totalValorNominaPorMes: 0,
    totalComision: 0,
    totalSalario: 0,
    totalPrestaciones: 0,
    totalBeneficios: 0,
    totalValorNomina: 0,
    ciem: null,
    detalles: []
};
const Empleadotable = (ciemId, tipoempleado, nombreHeaderTabla, nombreHeaderTablatotales, formEmpleado) => {
    const [empleados, setEmpleados] = useState(initialEmp);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editDetalle, setEditDetalle] = useState(null);
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [tableHeadersTotales, setTableHeadersTotales] = useState([]);
    const [error, setError] = useState(null);
    const [empleadoForm, setEmpleadoForm] = useState([]);
    const [infoModal, setInfoModal] = useState({ show: false, content: '' });

    const fetchEmpleados = async () => {
        try {
            //console.log(ciemId['nombreHeaderTabla'])
            //console.log(tipoEmpleado)
            //titulos y campos mercado Objetivo
            await axiosInstance.get(`/empleado/${ciemId.ciemId.ciemId}/${ciemId['tipoempleado']}`).then((response) => {
                if (response.data.data !== null) {
                    setEmpleados(response.data.data);
                } else {
                    initialEmp.ciem = ciemId.ciemId.ciemId;
                    setEmpleados(initialEmp);
                }
                console.log("tabla empleado")
                console.log(empleados)
            }).catch((e) => {
                alert("Error consultando la tabla " + e)
            });
        } catch (error) {
            setError('Error al cargar los detalles');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchTableHeaders = async () => {
        try {
            //titulos y campos mercado Objetivo
            await axiosInstance.get('/detailoption/option/value/' + ciemId['nombreHeaderTabla']).then((response) => {
                setTableHeaders(response.data.data);
                console.log("tabla empleado" + tableHeaders)
            }).catch((e) => {
                alert("Error consultando la tabla " + e)
            });

            //titulos y campos mercado Objetivo
            await axiosInstance.get('/detailoption/option/value/' + ciemId['nombreHeaderTablatotales']).then((response) => {
                setTableHeadersTotales(response.data.data);
                console.log("tabla header totales")
                console.log(tableHeadersTotales)
            }).catch((e) => {
                alert("Error consultando la tabla " + e)
            });

            //titulos y campos mercado Objetivo
            await axiosInstance.get('/detailoption/option/value/' + ciemId['formEmpleado']).then((response) => {
                setEmpleadoForm(response.data.data);
                console.log("tabla header totales" + tableHeaders)
            }).catch((e) => {
                alert("Error consultando la tabla " + e)
            });

        } catch (error) {
            setError('Error al cargar los detalles');
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchTableHeaders();
        fetchEmpleados();
    }, []);

    const openFormDetalle = (empleado, detalle = null) => {
        setEmpleadoSeleccionado(empleado);
        setEditDetalle(detalle);
        setShowModal(true);
    };

    const eliminarDetalle = async (detalleId) => {
        const newValue = parseFloat(detalleId);
        if (window.confirm('¿Eliminar este empleado?')) {
            try {
                await axiosInstance.delete(`/empleado/${newValue}`);
                fetchEmpleados();
            } catch (error) {
                console.error('Error eliminando detalle:', error);
            }
        }
    };

    const handleFormSubmit = async (data) => {
        console.log("guardando detalle")
        console.log(data)
        try {
            axiosInstance.post('/empleado/detail/save', data)
                .then((response) => {
                    fetchEmpleados();
                }).catch((e) => {
                    alert("Error consultando la tabla " + e)
                });
            setShowModal(false);
        } catch (error) {
            console.error('Error guardando detalle:', error);
        }
    };

    const submitEmpleados = async (data) => {
        try {
            await axiosInstance.post(`/empleado/`, data);
            fetchEmpleados();
        } catch (error) {
            console.error('Error guardando detalle:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmpleados((f) => ({ ...f, [name]: value }));
    };

    if (loading) {
        return <Spinner animation="border" />;
    }

    return (
        <Card className="p-3 shadow-sm">
            <Form>
                {empleadoForm.map((field) => (
                    <Form.Group key={field.value} className="mb-2">
                        <Form.Label>{field.description}</Form.Label>
                        <Form.Control
                            type="number"
                            name={field.value}
                            value={empleados[field.value] || ''}
                            onChange={handleChange}
                        />
                    </Form.Group>
                ))}
                <Button
                    size="sm"
                    variant="primary"
                    onClick={() => submitEmpleados(empleados)}
                    className="mb-2"
                >Guardar Procentajes</Button>
            </Form>
            <Button
                size="sm"
                variant="success"
                onClick={() => openFormDetalle()}
                className="mb-2"
            >
                + Agregar Empleado
            </Button>
            <React.Fragment key={empleados.id}>
                <div style={{ overflowX: "auto" }}>
                    <Table>
                        <tr>
                            <td colSpan="7" className="p-0">
                                <Accordion>
                                    <Accordion.Item>
                                        <Accordion.Header>Detalles del Empleado</Accordion.Header>
                                        <Accordion.Body>

                                            <Table size="sm" bordered>
                                                <thead>
                                                    {tableHeaders.map((titulo) => (
                                                        <th key={titulo.id}>
                                                            <span className="d-flex align-items-center gap-1">
                                                                {titulo.description}
                                                                {titulo.tooltip && (
                                                                    <Button
                                                                        variant="link"
                                                                        size="sm"
                                                                        className="p-0 text-info"
                                                                        onClick={() => setInfoModal({ show: true, content: titulo.tooltip })}
                                                                        title="Ver información"
                                                                    >
                                                                        <FontAwesomeIcon icon={faInfoCircle} />
                                                                    </Button>
                                                                )}
                                                            </span>
                                                        </th>
                                                    ))}
                                                </thead>
                                                <tbody>
                                                    {empleados.detalles.map((det) => (
                                                        <tr key={det.id}>
                                                            {tableHeaders.map((header, idx) => (
                                                                <td key={idx}>
                                                                    {det[header.value] || ""}
                                                                </td>
                                                            ))}
                                                            <td>
                                                                <Button size="sm" onClick={() => openFormDetalle(empleados, det)}>Editar</Button>{' '}
                                                                <Button size="sm" variant="danger" onClick={() => eliminarDetalle(det.id)}>Eliminar</Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td>Total</td>
                                                        {tableHeadersTotales.map((header, idx) => (
                                                            <td key={idx}>
                                                                {empleados[header.value] || ""}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </td>
                        </tr>
                    </Table>
                </div>
            </React.Fragment>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editDetalle ? 'Editar Detalle' : 'Nuevo Detalle'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EmpleadoForm
                        initialData={editDetalle}
                        empleado={empleados.id}
                        empleadoForm={tableHeaders}
                        tipoEmpleado={ciemId['tipoempleado']}
                        onSubmit={handleFormSubmit}
                        onCancel={() => setShowModal(false)}
                    />
                </Modal.Body>
            </Modal>

            {/* Modal de información */}
            <Modal show={infoModal.show} onHide={() => setInfoModal({ show: false, content: '' })} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Información</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{ __html: infoModal.content }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setInfoModal({ show: false, content: '' })}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Card>
    );
};

export default Empleadotable;